<template>
  <div class="row">
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :optional-audio-parameters="optionalAudioParameters"
      :parameters="node.parameters"
      @update:settings="updateNodeParent"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import messages from '../../../../locales';
import {
  createSettingsHierarchy,
} from '../../../../helpers/node';
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';

export default {
  name: 'RecordNodeProps',

  mixins: [nodePropsMixin],

  data() {
    return {
      optionalAudioParameters: Object.freeze(['message'])
    };
  },

  watch: {
    node() {
      this.buildNodeSettings();
    },
  },
  created() {
    this.buildNodeSettings();
  },
  methods: {
    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);

      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);


      this.handleMessage(this.settings.message);

      this.updateNodeParent();
    },
    handleMessage(settings) {
      if (settings.play.URL) {
        settings.isEnabled = true;
        settings.play.isEnabled = true;
      }
      if (settings.say.text) {
        settings.isEnabled = true;
        settings.say.isEnabled = true;
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>